import { useAutoLogout } from '../../utils/useAutoLogout';
import { useClearAppProviders } from '../../hooks/useClearAppProviders';

// Auto logout configuration
const TIMEOUT_MINUTES = 30;
const WARNING_MINUTES = 5;
const BUFFER_SECONDS = 5;

interface UseSessionTimeoutReturn {
  remainingTime: number;
  isBufferPeriod: boolean;
  timeoutMinutes: number;
  warningMinutes: number;
}

/**
 * Custom hook that manages session timeout with auto-logout functionality.
 * Clears all app providers (patient, cycle, clinic context) when session expires.
 */
export const useSessionTimeout = (): UseSessionTimeoutReturn => {
  const clearAppProviders = useClearAppProviders();

  // Auto logout after configured minutes of inactivity (with buffer)
  const { remainingTime, isBufferPeriod } = useAutoLogout({
    timeoutMinutes: TIMEOUT_MINUTES,
    bufferSeconds: BUFFER_SECONDS,
    onLogout: clearAppProviders,
  });

  return {
    remainingTime,
    isBufferPeriod,
    timeoutMinutes: TIMEOUT_MINUTES,
    warningMinutes: WARNING_MINUTES,
  };
};

export default useSessionTimeout;
